(() => {
  const INLINE_HOST = "#wair-inline-wrapper";
  const MODAL = ".wair-predict-modal";
  const WAIR_SNIPPET = ".predict-placement";

  const host = document.querySelector(INLINE_HOST);
  const TARGET_ELEMENT =
    document.querySelector("[data-target]")?.getAttribute("data-target") || "#wair-banner-placement";

  const inlineify = (element) => {
    const span = element.querySelector("span.wr-inset-0");
    if (span) {
      span.click();
    } else if (element instanceof HTMLButtonElement) {
      element.click();
    }
    const modal = document.querySelector(MODAL);
    host.appendChild(modal);
    document.body.style.position = "relative";
  };

  window.addEventListener("onPredictModalClose", () => {
    const sizeSnippet = document.querySelector(WAIR_SNIPPET);
    if (sizeSnippet) sizeSnippet.style.display = "flex";
  });

  window.addEventListener("onPredictModalOpen", () => {
    const sizeSnippet = document.querySelector(WAIR_SNIPPET);
    if (sizeSnippet) sizeSnippet.style.display = "none";
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) return;
        if (node.nodeType === 1 && (node.querySelector(TARGET_ELEMENT) || node.matches(TARGET_ELEMENT))) {
          observer.disconnect();
          inlineify(node);
        }
      }
    }
  });

  observer.observe(host, {childList: true, subtree: true});
})();
